import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const links = [
    { to: "/", label: "Inicio" },
    { to: "/centros", label: "Centros" },
    { to: "/ciudades", label: "Ciudades" },
    { to: "/regiones", label: "Regiones" },
    { to: "/modalidades", label: "Modalidades" },
    { to: "/blog", label: "Blog" },
    { to: "/nosotros", label: "Nosotros" },
];

export default function Header() {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 border-b border-slate-800 bg-slate-950/80 backdrop-blur-xl"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
                <Link
                    to="/"
                    data-testid="header-logo-link"
                    className="flex items-center gap-3"
                >
                    <img
                        src="https://sinadicciones.org/favicon-192x192.png"
                        alt="Centro de Rehabilitación de Drogas Chile"
                        className="h-9 w-9 rounded-md object-contain"
                    />
                    <div className="hidden flex-col leading-tight sm:flex">
                        <span className="text-sm font-bold tracking-tight text-slate-50">
                            Centro de Rehabilitación
                        </span>
                        <span className="text-xs text-cyan-400">
                            de Drogas · Chile
                        </span>
                    </div>
                </Link>

                <nav className="hidden items-center gap-1 md:flex">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                                    isActive
                                        ? "bg-slate-900 text-cyan-400"
                                        : "text-slate-300 hover:bg-slate-900 hover:text-slate-50"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden md:block">
                    <a
                        href="https://sinadicciones.org/agregar-centro"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="header-sinadicciones-cta"
                    >
                        <Button className="bg-cyan-500 text-slate-950 hover:bg-cyan-400">
                            Agregar mi centro
                        </Button>
                    </a>
                </div>

                <button
                    type="button"
                    aria-label="Abrir menú"
                    data-testid="header-mobile-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="rounded-md p-2 text-slate-300 hover:bg-slate-900 md:hidden"
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </div>

            {open ? (
                <div
                    data-testid="header-mobile-menu"
                    className="border-t border-slate-800 bg-slate-950 md:hidden"
                >
                    <nav className="mx-auto flex max-w-7xl flex-col px-4 py-3">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                                className={({ isActive }) =>
                                    `rounded-md px-3 py-3 text-base font-medium transition-colors ${
                                        isActive
                                            ? "bg-slate-900 text-cyan-400"
                                            : "text-slate-300 hover:bg-slate-900 hover:text-slate-50"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <a
                            href="https://sinadicciones.org/agregar-centro"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-2"
                            onClick={() => setOpen(false)}
                        >
                            <Button className="w-full bg-cyan-500 text-slate-950 hover:bg-cyan-400">
                                Agregar mi centro
                            </Button>
                        </a>
                    </nav>
                </div>
            ) : null}
        </header>
    );
}
